export default __webpack_public_path__ + "static/Museo-Sans-300-Italic-31ee264d98244f16b6d1bcce659dbff2.woff2";